angular.module("app.modalControllers").controller("ConfirmDeleteActionModalController", [
    '$scope',
    '$uibModalInstance',
    function ($scope, $modalInstance) {

        $scope.ok = function () {
            $modalInstance.close();
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

    }
]);